/**
 * Transform just added item to frontend format
 *
 * @since 1.0.0
 */

import { getCartItemQuantityFromFragments } from '@/frontend/transformers/cart-transformer';
import type { RedFoxCartProduct } from '@/frontend/types/cart';

import type { JustAddedItemData } from '../types';

/**
 * Transform just added item to frontend format
 *
 * @param justAddedItem - Just added item data from PHP fragments
 * @param cartFragments - Cart fragments to get actual cart quantity (optional)
 */
export const transformJustAddedItem = (
  justAddedItem: Record<string, unknown>,
  cartFragments?: Record<string, unknown>
): RedFoxCartProduct => {
  const typedItem = justAddedItem as JustAddedItemData;
  const productData = typedItem.product_data ?? {};

  // Get actual cart quantity from cart fragments if available
  let quantity = parseInt(String(typedItem.quantity_added ?? 1), 10) || 1;

  if (cartFragments && typedItem.cart_item_key) {
    const cartQuantity = getCartItemQuantityFromFragments(
      cartFragments,
      String(typedItem.cart_item_key)
    );
    if (cartQuantity !== null) {
      quantity = cartQuantity;
    }
  }

  return {
    name: String(productData.name ?? 'Unknown Product'),
    regular_price: parseFloat(String(productData.regular_price ?? 0)) || 0,
    sale_price: parseFloat(String(productData.sale_price ?? 0)) || 0,
    formatted_price: String(productData.formatted_price ?? '$0.00'),
    quantity,
    image_url: String(productData.image_url ?? ''),
    image_alt: String(productData.image_alt ?? productData.name ?? ''),
    is_on_sale: Boolean(productData.is_on_sale),
    is_variation: Boolean(productData.is_variation),
    variation_data:
      (productData.variation_data as RedFoxCartProduct['variation_data']) ?? undefined,
  };
};
